var alignment_default = {
  "alignLeft": "yZW6u",
  "textWrapNowrap": "_7H7d9",
  "alignRight": "jMBJT",
  "alignCenter": "KEH-b",
  "sizeFullWidth": "iLSy9",
  "renderedInTable": "ghw9c",
  "sizeOriginal": "X9-Mt",
  "sizeContent": "Ja3fl",
  "sizeSmall": "R8N52",
  "sizeSmallCenter": "UZjsJ",
  "flex": "nPPi2",
  "LEFT": "pKQYy",
  "CENTER": "MuLz1",
  "RIGHT": "po79R",
  "AUTO": "Wi6Am",
  "JUSTIFY": "bXFEY"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
